import { render, staticRenderFns } from "./SmartTableBody.vue?vue&type=template&id=f60c1ffc&scoped=true"
import script from "./SmartTableBody.vue?vue&type=script&lang=js"
export * from "./SmartTableBody.vue?vue&type=script&lang=js"
import style0 from "./SmartTableBody.vue?vue&type=style&index=0&id=f60c1ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60c1ffc",
  null
  
)

export default component.exports